// Vendors
import { deviceUtils } from '@openbank/cf-ui-architecture-core';

const isCompactView = (compactView: boolean): boolean =>
  deviceUtils.isMobileDevice() && compactView === true;

export { isCompactView };
